import * as React from 'react';
import * as Modal from 'react-modal';
import { NoteService } from '../services/noteService';
import { INoteData } from '../dto/INoteData';
import { noteTextToReact } from '../modules/helpers/noteTextFormatter';

type PropType = {
    regardingNote: INoteData;
    newTitle: string;
    newText: string;
    revertChanges:()=> void;
    saveChanges: ()=> void;
}

export default function UnsavedChangesModal(props: PropType) {
    return (
        <Modal isOpen={true} overlayClassName="modal__overlay" className="modal__window" contentLabel="Lägg till kategori" onRequestClose={props.revertChanges}>
            <button onClick={props.revertChanges} className="modal__close">Stäng</button>
            <div className="modal__content">
                <h2 className="modal__title">Du har osparade ändringar</h2>
                <div className={`modalNoteChangesWrapper modalNoteChangesWrapper--${props.regardingNote.color}`}>
                    {props.regardingNote.title !== props.newTitle && <>
                        <strong>Titel</strong>
                        <div className={`section ${props.regardingNote.text !== props.newText ? 'bordered' : ''}`}>
                            <div>
                                <p>Föregående</p>
                                <span className={"oldNoteProperty"}>{props.regardingNote.title ? props.regardingNote.title : <i>inget innehåll</i>}</span>
                            </div>
                            <div>
                                <p>Ny</p>
                                <span className={"newNoteProperty"}>{props.newTitle ? props.newTitle : <i>inget innehåll</i>}</span>
                            </div>
                        </div>
                    </>}
                    {props.regardingNote.text !== props.newText && <>
                        <strong>Brödtext</strong>
                        <div className='section'>
                            <div>
                                <p>Föregående</p>
                                <span className={"oldNoteProperty"}>{props.regardingNote.text ? noteTextToReact(props.regardingNote.text) : <i>inget innehåll</i>}</span>
                            </div>
                            <div>
                                <p>Ny</p>
                                <span className={"newNoteProperty"}>{props.newText ? noteTextToReact(props.newText) : <i>inget innehåll</i>}</span>
                            </div>
                        </div>
                    </>}
                </div>
                <div className="">
                    <button className={`button__primary`} onClick={props.saveChanges}>Spara dessa ändringar</button>
                    <button className="button__secondary" onClick={props.revertChanges}>Ta bort dessa ändringar</button>
                </div>
            </div>
        </Modal>
    )
}
